<form class="f-col blank-form" [formGroup]="travelCatForm">
    <div class="section-heading" *ngIf="!openingByPolicyConfiguration?.add">
        <h2 class="h2-heading">{{content?.['b2b.managecompany.tptravelcategory']}} <div class="dot">.</div> <span class="optional">{{content?.['b2b.managecompany.optional']}}</span></h2>
        <a role="button" class="link" *ngIf="travelCategory.length>0&& !Addnew"
            (click)="addNewTravelCat()"><mat-icon fontSet="material-symbols-outlined" class="edit-icon">add</mat-icon> {{content?.['b2b.managecompany.addnew']}}</a>
    </div>

    <!-- <app-cam-empty-state></app-cam-empty-state> -->

    <div class="section-content" *ngIf="Addnew">
        <div class="inner-contentsection">
            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.tptravelcategory']}}</mat-label>
                        <input matInput formControlName="travelCategoryName" (contextmenu)="disableRightClick($event)" (paste)="onPasteBlocked($event)" (keypress)="blockInvalidCharacters1($event)">
                        <mat-error *ngIf="travelCatForm.get('travelCategoryName')?.hasError('required')">{{dictionaryContent?.['b2b.managecompany.travelcategoryreq']}}</mat-error>
                        <mat-error *ngIf="travelCatForm.get('travelCategoryName')?.hasError('maxlength')">{{dictionaryContent?.['b2b.managecompany.travelcategorymaxlimit']}}</mat-error>
                        <mat-error *ngIf="travelCatForm.get('travelCategoryName')?.hasError('minlength')">{{dictionaryContent?.['b2b.managecompany.travelcategoryminlimit']}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.tpcategorycode']}}</mat-label>
                        <input matInput formControlName="travelCategoryCode" (contextmenu)="disableRightClick($event)" (paste)="onPasteBlocked($event)"
                        (keypress)="blockInvalidCharacters1($event)">
                        <mat-error *ngIf="travelCatForm.get('travelCategoryCode')?.hasError('required')">{{dictionaryContent?.['b2b.managecompany.categorycodereq']}}</mat-error>
                        <mat-error *ngIf="travelCatForm.get('travelCategoryCode')?.hasError('maxlength')">{{dictionaryContent?.['b2b.managecompany.categorycode30char']}}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="f-row">
                <div class="f-col">
                    <div class="f-row validation-col col-direction-column">
                        <label class="mat-label">{{content?.['b2b.managecompanytravelpurpose']}} </label>
                        <mat-radio-group aria-label="Select an option" formControlName="travelCategoryType">
                            <mat-radio-button selected [value]="'BTC'" selected>{{content?.['b2b.managecompany.tpbusinesstrip']}}</mat-radio-button>
                            <mat-radio-button [value]="'FTC'">{{content?.['b2b.managecompany.tpfamilytrip']}}</mat-radio-button>
                            <mat-radio-button [value]="'GTC'">{{content?.['b2b.managecompany.tpguestuser']}}</mat-radio-button>
                        </mat-radio-group>

                        <div *ngIf="travelCatForm.get('travelCategoryType')?.invalid && travelCatForm.get('travelCategoryType')?.touched"
                            class="error-message">
                            {{dictionaryContent?.['b2b.managecompany.travelcategorytypereq'] || 'Travel Category Type is required.'}}
                        </div>

                    </div>
                </div>
            </div>

            <div class="f-row">
                <div class="f-col">
                    <div class="f-row validation-col">
                        <label class="mat-label">{{content?.['b2b.managecompany.tpapplytravelpolicy']}}</label>
                        <mat-radio-group aria-label="Select an option" formControlName="applyTravelPolicy">
                            <mat-radio-button selected [value]="true">{{content?.['b2b.managecompany.yes']}}</mat-radio-button>
                            <mat-radio-button [value]="false">{{content?.['b2b.managecompany.no']}}</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>

            <div class="f-row">
                <div class="f-col">
                    <div class="f-row validation-col">
                        <label class="mat-label">{{content?.['b2b.managecompany.status']}}</label>
                        <mat-radio-group aria-label="Select an option" formControlName="status">
                            <mat-radio-button selected [value]=true>{{content?.['b2b.managecompany.active']}}</mat-radio-button>
                            <mat-radio-button [value]=false>{{content?.['b2b.managecompany.inactive']}}</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>
        </div>

        <div class="inner-action">
            <button mat-button class="button--secondary-small" (click)="onCancel()">{{content?.['b2b.managecompany.cancel']}}</button>
            <button mat-button class="button--primary-small" (click)="onSave()" [class.disabled]="travelCatForm.invalid">{{content?.['b2b.managecompany.save']}}</button>
        </div>
    </div>

    <div class="section-table data-listing" *ngIf="travelCategory.length>0 && !Addnew">
        <table mat-table [dataSource]="travelCategory" class="mat-elevation-z0">
            <!-- Position Column -->
            <ng-container matColumnDef="Travel Category">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.tptravelcategory']}} </th>
                <td mat-cell *matCellDef="let element"> {{element.travelCategory}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="Status">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.ddstatus']}} </th>
                <td mat-cell *matCellDef="let element" class="status-tag">
                    <span [ngClass]="element.status  ? 'status-active' : 'status-inactive'"> {{ element.status ? content?.['b2b.managecompany.active'] : content?.['b2b.managecompany.inactive'] }} </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="Actions">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.ddactions']}} </th>
                <td mat-cell *matCellDef="let element" class="onclick-links">
                    <a tabindex="0" role="button" aria-label="Edit item" class="onclick-cell primary-link" (keydown.enter)="onEdit(element)" (click)="onEdit(element)">{{content?.['b2b.managepolicy.edit'] || 'Edit'}}</a>
                    <a tabindex="0" role="button" aria-label="Remove item" class="onclick-cell warm-link" (keydown.enter)="onRemove(element)" (click)="onRemove(element)">{{content?.['b2b.managepolicy.remove'] || 'Remove'}}</a>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <ng-container *ngIf="!isLoading && travelCategory.length==0 && !Addnew">
        <app-cam-empty-state (myEvent)="handleEvent($event)" [heading]="content?.['b2b.managecompany.tpnotravelcategorytitle'] ||'No Travel category details added'"
            [content]="content?.['b2b.managecompany.tpnotravelcategorydesc']"
            [navigateTo]="'/cam/company-management/travel-category'">
        </app-cam-empty-state>
    </ng-container>
</form>

<ng-template #selectionWarning>
    <div class="custom-dialog">
        <div class="d-justify-bw">
            <div class="custom-dialog__left">
                <div class="mat-dialog-title custom-dialog__title d-justify-bw">
                    <h2 class="mat-dialog-title"> {{content?.warningList[0]?.title}}</h2>
                    <!-- <div class="custom-overlay-close">
                        <mat-icon fontSet="material-symbols-outlined" class="close_icon" (click)="CloseDialog(false)">close</mat-icon>
                    </div> -->
                </div>
                <mat-dialog-content class="custom-dialog__text">
                    <div class="custom-dialog__description">{{content?.['b2b.managepolicy.removetravelcategory'] || 'Are you sure you want to remove this Travel category?'}}</div>
                </mat-dialog-content>
                <mat-dialog-actions>
                    <div class="dialog-actions-right">
                        <button class="button--secondary-small" mat-button (click)="CloseDialog(false)">{{content?.warningList[0]?.cancelCTAText}}</button>
                        <button class="button--primary-small" mat-button (click)="CloseDialog(true)">{{content?.warningList[0]?.confirmCTAText}}</button>
                    </div>
                </mat-dialog-actions>
            </div>
        </div>
    </div>
</ng-template>
